var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadWet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_2162_22470)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6098 4.56256C10.3838 4.52272 10.1597 4.64177 10.0663 4.85131L9.38559 6.37757L16.2792 7.5931L16.1616 5.92608C16.1455 5.69722 15.9756 5.50871 15.7497 5.46887L10.6098 4.56256Z",
    fill: "url(#paint1_linear_2162_22470)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71954 7.27555C8.4476 7.2276 8.18827 7.40918 8.14032 7.68113L7.79302 9.65074C7.74507 9.92269 7.92665 10.182 8.1986 10.23L16.0771 11.6192C16.349 11.6671 16.6083 11.4855 16.6563 11.2136L17.0036 9.24396C17.0515 8.97202 16.87 8.71269 16.598 8.66473L8.71954 7.27555Z",
    fill: "url(#paint2_linear_2162_22470)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.487 11.6489L8.02495 11.2148L7.93813 11.7072C7.89017 11.9791 8.07176 12.2385 8.34371 12.2864L9.82092 12.5469C10.0929 12.5948 10.3522 12.4133 10.4001 12.1413L10.487 11.6489Z",
    fill: "url(#paint3_linear_2162_22470)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4414 12.1698L15.9034 12.604L15.8166 13.0964C15.7686 13.3683 15.5093 13.5499 15.2374 13.5019L13.7601 13.2415C13.4882 13.1935 13.3066 12.9342 13.3546 12.6622L13.4414 12.1698Z",
    fill: "url(#paint4_linear_2162_22470)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09843 13.59C7.14638 13.318 7.40571 13.1364 7.67765 13.1844C8.19222 13.2751 8.96376 13.4634 9.60195 13.7408C9.9175 13.878 10.2366 14.0522 10.4744 14.2729C10.7116 14.4931 10.9408 14.834 10.864 15.2694C10.8129 15.5595 10.6372 15.7633 10.4291 15.8896C10.2378 16.0058 10.016 16.0604 9.81684 16.09C9.42962 16.1474 8.95072 16.1317 8.53171 16.118L8.50164 16.117C8.04426 16.1021 7.6535 16.0911 7.36575 16.1338C7.31385 16.1415 7.2715 16.1501 7.23734 16.1588C7.25519 16.1737 7.27662 16.1904 7.30229 16.209C7.49091 16.3453 7.79244 16.4902 8.17528 16.6311C8.932 16.9096 9.87657 17.1261 10.5167 17.239C10.7887 17.2869 10.9702 17.5463 10.9223 17.8182C10.8743 18.0902 10.615 18.2718 10.3431 18.2238C9.67013 18.1051 8.66245 17.8759 7.82992 17.5695C7.41813 17.418 7.01578 17.2357 6.71655 17.0195C6.45143 16.8279 6.08255 16.4719 6.1719 15.9652C6.22305 15.6751 6.3987 15.4713 6.60681 15.3449C6.79809 15.2288 7.01992 15.1741 7.21907 15.1446C7.60629 15.0872 8.0852 15.1028 8.50421 15.1166L8.53427 15.1175C8.99165 15.1325 9.38241 15.1435 9.67016 15.1008C9.7506 15.0889 9.8081 15.0746 9.84772 15.0615C9.83513 15.0463 9.8178 15.0278 9.79404 15.0058C9.67728 14.8974 9.47719 14.777 9.20327 14.6579C8.66255 14.4228 7.97424 14.2521 7.50401 14.1692C7.23206 14.1213 7.05047 13.8619 7.09843 13.59ZM9.87979 15.1151C9.87979 15.1151 9.87845 15.1127 9.87825 15.1081C9.8801 15.1129 9.87979 15.1151 9.87979 15.1151Z",
    fill: "url(#paint5_linear_2162_22470)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5865 14.2263C13.3146 14.1783 13.0552 14.3599 13.0073 14.6319C12.9593 14.9038 13.1409 15.1631 13.4129 15.2111C13.8831 15.294 14.5714 15.4647 15.1121 15.6998C15.386 15.8189 15.5861 15.9393 15.7029 16.0477C15.7266 16.0697 15.744 16.0882 15.7566 16.1034C15.7169 16.1165 15.6594 16.1307 15.579 16.1427C15.2913 16.1853 14.9005 16.1744 14.4431 16.1594L14.4131 16.1584C13.994 16.1447 13.5151 16.129 13.1279 16.1865C12.9288 16.216 12.7069 16.2706 12.5157 16.3868C12.3075 16.5132 12.1319 16.717 12.0807 17.0071C11.9914 17.5138 12.3603 17.8698 12.6254 18.0614C12.9246 18.2776 13.327 18.4599 13.7388 18.6114C14.5713 18.9178 15.579 19.147 16.2519 19.2657C16.5239 19.3136 16.7832 19.1321 16.8311 18.8601C16.8791 18.5882 16.6975 18.3288 16.4256 18.2809C15.7854 18.168 14.8408 17.9514 14.0841 17.673C13.7013 17.5321 13.3998 17.3872 13.2111 17.2509C13.1855 17.2323 13.164 17.2156 13.1462 17.2007C13.1804 17.192 13.2227 17.1833 13.2746 17.1756C13.5623 17.133 13.9531 17.144 14.4105 17.1589L14.4406 17.1599C14.8596 17.1736 15.3385 17.1893 15.7257 17.1319C15.9248 17.1023 16.1467 17.0477 16.3379 16.9315C16.5461 16.8051 16.7217 16.6013 16.7729 16.3113C16.8496 15.8759 16.6204 15.5349 16.3832 15.3148C16.1455 15.0941 15.8263 14.9199 15.5108 14.7827C14.8726 14.5053 14.1011 14.317 13.5865 14.2263ZM15.7886 16.157C15.7886 16.157 15.7873 16.1546 15.7871 16.15C15.7889 16.1548 15.7886 16.157 15.7886 16.157Z",
    fill: "url(#paint6_linear_2162_22470)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_22470",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCCD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_22470",
    x1: 13.6721,
    y1: 5.10253,
    x2: 11.3279,
    y2: 18.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_22470",
    x1: 13.6721,
    y1: 5.10253,
    x2: 11.3279,
    y2: 18.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_22470",
    x1: 13.6721,
    y1: 5.10253,
    x2: 11.3279,
    y2: 18.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2162_22470",
    x1: 13.6721,
    y1: 5.10253,
    x2: 11.3279,
    y2: 18.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2162_22470",
    x1: 13.6721,
    y1: 5.10253,
    x2: 11.3279,
    y2: 18.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2162_22470",
    x1: 13.6721,
    y1: 5.10253,
    x2: 11.3279,
    y2: 18.3974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD4185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9982"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadWet);
export default __webpack_public_path__ + "static/media/RoadWet.52bb383225f6fa4b22e9440683cdbfb9.svg";
export { ForwardRef as ReactComponent };